import { gt, isEqual } from 'lodash-es'

import { Branch } from './Branch'
import { ActivityLocation, CustomerResult } from './MovingContractModels'

class GeoCoord {
  latitude: number
  longitude: number

  constructor(latitude: number, longitude: number) {
    this.latitude = latitude
    this.longitude = longitude
  }

  isCartesianOrigin = (): boolean => {
    return isEqual(this.latitude, 0) && isEqual(this.longitude, 0)
  }
}

class ReorderEmmaApiRequest {
  contractId = ''
  activityId = ''
  locations: ActivityLocation[] = []
}

const ORIGIN_GEO_COORDINATE = new GeoCoord(0, 0)

enum DriveTimeCalculationStatuses {
  NeedsCoordinates = 'NeedsCoordinates',
  InError = 'InError',
  EligibleForFetching = 'EligibleForFetching',
  Done = 'Done',
}

class DriveTimeFetchParamsBuildRequest {
  branches: Branch[]
  customer: CustomerResult
  currentLocationIndex: number
  locations: ActivityLocation[]
  fromIndex: number

  constructor(
    customer: CustomerResult,
    branches: Branch[],
    locations: ActivityLocation[],
    currentLocationIndex: number,
    fromIndex: number,
  ) {
    this.customer = customer
    this.branches = branches
    this.currentLocationIndex = currentLocationIndex
    this.locations = locations
    this.fromIndex = fromIndex
  }
}

class DriveTimeFetchWorkItem {
  driveTimeFetchStatus: string = DriveTimeCalculationStatuses.NeedsCoordinates
  coordinates: GeoCoord = ORIGIN_GEO_COORDINATE
  driveTime = '0'
  driveDistance = '0'
  id: string | null | undefined = null
  isForPrecedingLocation = false

  isDone = () => {
    return isEqual(this.driveTimeFetchStatus, DriveTimeCalculationStatuses.Done)
  }
}

class DistanceMatrixMappings {
  item: DriveTimeFetchWorkItem | null | undefined = null
  originIndex = -1
  destinationIndex = -1

  wasSentAcrossTheWire = () => {
    return gt(this.originIndex, -1) && gt(this.destinationIndex, -1)
  }
}

class DriveTimeFetchWorkload {
  precedingLocationItem: DriveTimeFetchWorkItem | null = null
  currentLocationItem: DriveTimeFetchWorkItem = new DriveTimeFetchWorkItem()
  nextLocationItem: DriveTimeFetchWorkItem | null = null
  currentLocationIndex = 0
  sourcePrecedingLocationItem: DriveTimeFetchWorkItem | null = null
  sourceLocationItem: DriveTimeFetchWorkItem = new DriveTimeFetchWorkItem()
  locations: ActivityLocation[] = []
  origins: GeoCoord[] = []
  destinations: GeoCoord[] = []
  distanceMatrixMaps: DistanceMatrixMappings[] = []

  addTodistanceMatrixMaps = (entry: DistanceMatrixMappings) => {
    this.distanceMatrixMaps.push(entry)
  }
}

export {
  DistanceMatrixMappings,
  DriveTimeCalculationStatuses,
  DriveTimeFetchParamsBuildRequest,
  DriveTimeFetchWorkItem,
  DriveTimeFetchWorkload,
  GeoCoord,
  ReorderEmmaApiRequest,
}
